export default "__VITE_ASSET__C7O0H5km__"